import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  TenantByDomainArgs,
  FetchTenantsArgs,
  TenantByIdArgs,
} from '../api/types/tenant.types';

import {
  fetchTenantContentHandover,
  fetchTenantPremiumPlans,
  fetchTenantReadiness,
  fetchTenantByDomain,
  fetchTenantById,
  fetchTenants,
} from '../api/tenant.api';

export const tenantsQueryKeys = createQueryKeys('tenants', {
  byDomain: ({ domain }: TenantByDomainArgs) => ({
    queryFn: async () => fetchTenantByDomain({ domain }),
    queryKey: [domain],
  }),
  byId: ({ id }: TenantByIdArgs) => ({
    queryFn: async () => fetchTenantById({ id }),
    queryKey: [id],
  }),
  premiumPlans: ({ id }: TenantByIdArgs) => ({
    queryFn: async () => fetchTenantPremiumPlans({ id }),
    queryKey: [id],
  }),
  contentHandover: ({ id }: TenantByIdArgs) => ({
    queryFn: async () => fetchTenantContentHandover({ id }),
    queryKey: [id],
  }),
  readiness: ({ id }: TenantByIdArgs) => ({
    queryFn: async () => fetchTenantReadiness({ id }),
    queryKey: [id],
  }),
  fetchTenants: ({ filters }: FetchTenantsArgs) => ({
    queryFn: () => fetchTenants({ filters }),
    queryKey: [filters],
  }),
});
